import { render, staticRenderFns } from "./carouselPromociones.vue?vue&type=template&id=f8eced06&scoped=true&"
import script from "./carouselPromociones.vue?vue&type=script&lang=js&"
export * from "./carouselPromociones.vue?vue&type=script&lang=js&"
import style0 from "./carouselPromociones.vue?vue&type=style&index=0&id=f8eced06&scoped=true&lang=css&"
import style1 from "./carouselPromociones.vue?vue&type=style&index=1&id=f8eced06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8eced06",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/ALIO/APP/APPVentas/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib'
import { VCarouselItem } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VExpansionPanel } from 'vuetify/lib'
import { VExpansionPanelContent } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VCarousel,VCarouselItem,VContainer,VExpansionPanel,VExpansionPanelContent,VFlex,VLayout})
